import React, { useEffect, useState } from "react";
import "./Popup.css";
import { ReserGuaranteeCodes } from "../../../../Services/Service";
import { useProperty } from "../../../../PropertyContext";

const ReservationTypePopup = ({ show, onClose, onSelect }) => {
  const { selectedProperty } = useProperty();
  const [guaranteeCodes, setGuaranteeCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const fetchGuaranteeCodes = async () => {
      setLoading(true);
      try {
        const data = await ReserGuaranteeCodes(selectedProperty?.PropertyID);
        setGuaranteeCodes(Array.isArray(data) ? data : []);
      } catch (error) {
        console.log("Error fetching guarantee codes:", error);
        setGuaranteeCodes([]);
      } finally {
        setLoading(false);
      }
    };

    if (selectedProperty?.PropertyID) fetchGuaranteeCodes();
  }, [selectedProperty]);

  useEffect(() => {
    if (!show) return undefined;
    setSearchText("");
    setSelectedId(null);

    const handleEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [show, onClose]);

  if (!show) return null;

  const searchValue = searchText.replace(/\*/g, "").trim().toLowerCase();
  const filteredCodes = guaranteeCodes.filter((item) =>
    `${item.Code} ${item.guaranteeCodes}`.toLowerCase().includes(searchValue),
  );
  const selectedCode = guaranteeCodes.find((item) => item.ID === selectedId);

  return (
    <div
      className="bon-lookup-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="modal-dialog modal-dialog-centered bon-lookup-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="reservationTypePopupTitle"
      >
        <div className="modal-content">
          <div className="modal-header bon-lookup-header">
            <h5 id="reservationTypePopupTitle" className="modal-title">
              Search and Select Reservation Type
            </h5>
            <button
              type="button"
              className="btn-close bon-popup-close"
              aria-label="Close reservation type popup"
              onClick={onClose}
            />
          </div>

          <div className="modal-body">
            <div className="input-group bon-popup-search">
              <input
                type="search"
                className="form-control"
                placeholder="Search by code or description"
                value={searchText}
                onChange={(event) => setSearchText(event.target.value)}
                autoFocus
              />
              <button type="button" className="btn bon-search-button">
                Search
              </button>
            </div>

            <div className="table-responsive bon-popup-table-wrap">
              <table className="table table-sm table-hover mb-0 bon-popup-table">
                <thead>
                  <tr>
                    <th scope="col">Code</th>
                    <th scope="col">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="2" className="text-center py-4">Loading...</td></tr>
                  ) : filteredCodes.length ? (
                    filteredCodes.map((item) => (
                      <tr
                        key={item.ID}
                        className={selectedId === item.ID ? "bon-row-selected" : ""}
                        onClick={() => setSelectedId(item.ID)}
                        onDoubleClick={() => onSelect(item)}
                      >
                        <td>{item.Code}</td>
                        <td>{item.guaranteeCodes}</td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="2" className="text-center py-4">No matching reservation type found.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer bon-lookup-footer">
            <button type="button" className="btn bon-cancel-button" onClick={onClose}>
              Cancel
            </button>
            <button
              type="button"
              className="btn bon-select-button"
              disabled={!selectedCode}
              onClick={() => onSelect(selectedCode)}
            >
              Select
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReservationTypePopup;
